export default {
    showLoading() {
        $('#loadingSpinner').fadeIn();
    },

    hideLoading() {
        $('#loadingSpinner').fadeOut();
    },
}


// WEBPACK FOOTER //
// ./scripts/util/loadingLayer.js